import React, { useState, useContext, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import ChatIcon from "@material-ui/icons/Chat";

import Ticket from "../../components/Ticket";
import MobileTicketList from "./MobileTicketList";
import MobileBottomNav from "./MobileBottomNav";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    overflow: "hidden",
    position: "relative",
  },
  chatContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    // Leave space for bottom nav only when NOT in chat
  },
  chatContainerWithNav: {
    paddingBottom: 56, // bottom nav height
  },
  ticketWrapper: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    color: theme.palette.text.secondary,
    padding: 32,
    paddingBottom: 88,
  },
}));

const MobileChat = () => {
  const classes = useStyles();
  const { ticketId } = useParams();
  const history = useHistory();
  const { currentTicket, setCurrentTicket } = useContext(TicketsContext);
  const [bottomTab, setBottomTab] = useState(0);

  const isInChat = !!ticketId;

  // When entering a ticket, set bottomTab to conversations
  useEffect(() => {
    if (ticketId) {
      setBottomTab(0);
    }
  }, [ticketId]);

  const handleBottomTabChange = (newValue) => {
    setBottomTab(newValue);
    // If switching to conversations tab while no ticket selected, go to list
    if (newValue === 0 && ticketId) {
      history.push("/mobile/tickets");
    }
  };

  // When in a chat, show full-screen ticket (no bottom nav)
  if (isInChat) {
    return (
      <div className={classes.root}>
        <div className={classes.ticketWrapper}>
          <Ticket />
        </div>
      </div>
    );
  }

  // When on list view, show ticket list or contacts/profile + bottom nav
  return (
    <div className={classes.root}>
      <div className={`${classes.chatContainer} ${classes.chatContainerWithNav}`}>
        {bottomTab === 0 && <MobileTicketList />}
        {/* Contacts and Profile panels are rendered inside MobileBottomNav */}
      </div>
      <MobileBottomNav
        activeTab={bottomTab}
        onTabChange={handleBottomTabChange}
        visible={true}
      />
    </div>
  );
};

export default MobileChat;
